import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {ModalWindowComponent} from "../../std-components/modal-window/modal-window.component";
import {BuildingWallMaterials, ISpot, WallMaterial, WallMaterialType} from "../../shared/models/models";
import {ServerService} from "../../shared/services/server.service";
import {CommonModule} from "@angular/common";
import {FormsModule} from "@angular/forms";


@Component({
  selector: 'app-wall-material',
  templateUrl: './wall-material.component.html',
  styleUrls: ['./wall-material.component.scss'],
  standalone: true,
  imports: [CommonModule, FormsModule]
})

export class WallMaterialComponent implements OnInit {

    @Input() spotObjectAddAppartments: ISpot;
    @Input() isOneChecked: boolean;

    @Output() isOneChange = new EventEmitter<boolean>();

    wallMaterials: WallMaterialType[] = [];
    buildingWallMaterials: BuildingWallMaterials;
    onchangeModel = false;

    constructor(private modalWindow: ModalWindowComponent,
                private serverService: ServerService) {}

    ngOnInit() {
        this.buildingWallMaterials = {buildingID: null, wallMaterialsList: []};
        let new_materials: WallMaterialType;
        if (this.spotObjectAddAppartments.wallMaterials.length > 0) {
            for (let materials of this.spotObjectAddAppartments.wallMaterials) {
                new_materials = {id: 0, title: '', wall_material: [], active: false};
                new_materials.id = materials.id;
                new_materials.title = materials.title;
                new_materials.active = materials.active;
                for(let item of materials.wall_material){
                    new_materials.wall_material.push(Object.assign({}, item));
                }
                this.wallMaterials.push(new_materials);
            }
        }
    }

    changedModel() {
        this.onchangeModel = true;
        let karkas = this.wallMaterials.find(x => x.id == 4);
            if (karkas.wall_material.find(x => x.id == 420).checked == false) {
               karkas.wall_material.forEach(r => {
                if (r.id > 420) {
                    r.checked = false;
                }
            });
            }
    }

    cancel(){
        this.wallMaterials = [];
        this.buildingWallMaterials = null;
        this.modalWindow.closeModalWindow();
    }

    changeActiveState(wallMaterial: WallMaterialType){
        this.wallMaterials.forEach(r => r.active = false);
        wallMaterial.active = true;
    }

    saveState(){
        this.buildingWallMaterials.buildingID = this.spotObjectAddAppartments.id;
        this.buildingWallMaterials.wallMaterialsList = [];
        this.isOneChecked = false;
        for(let i=0; i<this.wallMaterials.length; i++){
            for(let j=0; j<this.wallMaterials[i].wall_material.length; j++){
                this.spotObjectAddAppartments.wallMaterials[i].wall_material[j].checked = this.wallMaterials[i].wall_material[j].checked;
                if(this.wallMaterials[i].wall_material[j].checked){
                    this.buildingWallMaterials.wallMaterialsList.push(this.wallMaterials[i].wall_material[j].id);
                    this.isOneChecked = true;
                }
            }
        }
        this.serverService.setBuildingsWallMaterials(this.buildingWallMaterials).then(res => {
            this.isOneChange.emit(this.isOneChecked);
            this.buildingWallMaterials = null;
            this.modalWindow.closeModalWindow();
        });
    }

    closeSelectedMaterial(type: WallMaterial){
        type.checked = !type.checked;
    }

}

